exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".topic-editor {\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.topic-editor--wrapper {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    max-width: 855px;\n    padding: 0 31px 31px 19px;\n    min-height: calc(100vh - 125px);\n    margin-right: 30px;\n}\n\n.topic-editor--sidebar {\n    width: 266px;\n}\n\n.topic-editor--title {\n    font-size: 24px;\n    line-height: 1em;\n}\n\n.topic-editor--fields {\n    padding-top: 7px;\n}\n\n.topic-editor--field {\n    font-size: 14px!important;\n    line-height: 1.29em!important;\n    margin-bottom: 12px;\n    margin-top: -3px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/topics/topic-editor.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/topics/topic-editor.css
// module chunks = 0